// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XEg_c","footer":"styles_footer__2px4L","passCodeTooltip":"styles_passCodeTooltip__10I2p"};